/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesRole } from './WebApiModelsEnumerationTypesRole';
import {
    WebApiModelsEnumerationTypesRoleFromJSON,
    WebApiModelsEnumerationTypesRoleFromJSONTyped,
    WebApiModelsEnumerationTypesRoleToJSON,
} from './WebApiModelsEnumerationTypesRole';

/**
 * 
 * @export
 * @interface WebApiCompanyDtoCompanyInviteDto
 */
export interface WebApiCompanyDtoCompanyInviteDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCompanyDtoCompanyInviteDto
     */
    id?: number;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesRole}
     * @memberof WebApiCompanyDtoCompanyInviteDto
     */
    role?: WebApiModelsEnumerationTypesRole;
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyInviteDto
     */
    inviteEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyInviteDto
     */
    inviteId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiCompanyDtoCompanyInviteDto
     */
    userAlreadyExists?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WebApiCompanyDtoCompanyInviteDto
     */
    companyName?: string | null;
}

/**
 * Check if a given object implements the WebApiCompanyDtoCompanyInviteDto interface.
 */
export function instanceOfWebApiCompanyDtoCompanyInviteDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCompanyDtoCompanyInviteDtoFromJSON(json: any): WebApiCompanyDtoCompanyInviteDto {
    return WebApiCompanyDtoCompanyInviteDtoFromJSONTyped(json, false);
}

export function WebApiCompanyDtoCompanyInviteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCompanyDtoCompanyInviteDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'role': !exists(json, 'role') ? undefined : WebApiModelsEnumerationTypesRoleFromJSON(json['role']),
        'inviteEmail': !exists(json, 'inviteEmail') ? undefined : json['inviteEmail'],
        'inviteId': !exists(json, 'inviteId') ? undefined : json['inviteId'],
        'userAlreadyExists': !exists(json, 'userAlreadyExists') ? undefined : json['userAlreadyExists'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
    };
}

export function WebApiCompanyDtoCompanyInviteDtoToJSON(value?: WebApiCompanyDtoCompanyInviteDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'role': WebApiModelsEnumerationTypesRoleToJSON(value.role),
        'inviteEmail': value.inviteEmail,
        'inviteId': value.inviteId,
        'userAlreadyExists': value.userAlreadyExists,
        'companyName': value.companyName,
    };
}

